module.exports = __webpack_public_path__ + "img/arrow-circle-up.99f2a42b.svg";